<template>
  <v-container>
    <p v-if="!noNetwork" class="primary--text text-center display-2">{{$t('DataHome.title')}}</p>
    <br />
    <v-alert type="warning" v-if="ready && noNetwork">{{$t('DataHome.alert-nonetwork')}}</v-alert>

    <template v-if="loading && !noNetwork">
      <v-row justify="center">
        <v-col>
          <div class="text-center mt-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col v-for="net in networksArray" :key="net.networkId" cols="12" sm="4">
          <v-hover v-slot:default="{ hover }">
            <v-card
              :id="net.networkId"
              style="cursor: pointer;"
              :elevation="hover ? 10 : 2"
              class="mx-auto"
              max-width="344"
              @click="sendChoosenNetwork($event)"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="subtitle-2 mb-4 text-uppercase">{{net.networkId}}</div>
                  <v-list-item-title class="headline mb-1">{{net.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{net.description}}</v-list-item-subtitle>
                  <v-system-bar color="transparent">
                    <v-spacer></v-spacer>
                    <v-chip
                      v-for="scope in net.scopes"
                      :key="scope"
                      class="mt-2 ml-1 mb-1"
                      :color="scopeColor(scope)"
                      text-color="white"
                      small
                    >{{scope}}</v-chip>
                  </v-system-bar>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    source: String
  },
  data: () => ({
    userId: null,
    username: null,
    mail: null,
    networks: [],
    noNetwork: true,
    ready: false,
    loading: true
  }),
  computed: {
    networksArray: function() {
      let array = this.networks;
      function compare(d1, d2) {
        let a = d1.name;
        let b = d2.name;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }
      if (array != undefined) {
        return array.sort(compare);
      } else {
        return array;
      }
    }
  },
  watch: {
    networksArray: function() {
      this.loading = false;
    }
  },
  methods: {
    sendChoosenNetwork: function(event) {
      let index = this.networks.findIndex(e => {
        return e.networkId == event.currentTarget.id;
      });
      this.$emit("choosennetwork", this.networks[index]);
    },
    scopeColor: function(scope) {
      switch (scope) {
        default:
          return "primary";

        case "admin":
          return "red";

        case "creator":
          return "#981b00";
      }
    }
  },
  beforeMount: function() {
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/user/@me", {
        headers: { Authorization: tokenStore.getToken() }
      })
      .then(res => {
        if (res.data.user.permissions.networks.length == 0)
          this.noNetwork = true;
        else {
          this.noNetwork = false;
          this.mail = res.data.user.mail;
          this.username = res.data.user.username;
          this.userId = res.data.user.id;
          let $networks = res.data.user.permissions.networks;
          $networks.forEach(network => {
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/network/" +
                  network.networkId,
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                network.name = res.data.network.name;
                network.description = res.data.network.description;
                this.networks.push(network);
              })

              .catch(err => {
                console.log(err);
                tokenStore.refreshToken();
              });
          });
        }
        this.ready = true;
      })
      .catch(err => {
        console.log(err);
        tokenStore.refreshToken();
      });
  }
};
</script>
